import React from 'react'
import {MdDelete, MdEdit, MdRefresh} from 'react-icons/md';
import {
    Media,
    Badge,
    Button
} from "reactstrap";
import {Redirect} from "react-router-dom";
import dateHelpers from "../../helpers/DateHelper";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";

const resourceStrings = new LocalizedStrings(resource_strings);
const commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class TicketTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ticket: props.ticket,
            goToClient: false
        };

        this.goToClient = this.goToClient.bind(this);
    }

    goToClient(e) {
        this.setState({
            goToClient: true,
        });
    }

    calcClassesLeft() {
        if (this.state.ticket) {
            let cl = parseInt(this.state.ticket.classes_left);
            if (cl > -1) {
                return cl.toString()
            } else if (cl === -5) {
                return resourceStrings.unlimited
            } else {
                return "??"
            }
        } else {
            return "?"
        }
    }

    render() {
        this.localize();

        if (this.state.goToClient) {
            return <Redirect from="*" to={"/admin/student-profile?id=" + this.state.ticket.id}/>
        }

        return (
            <tr>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm" style={{cursor: "pointer", display: "flex", flexFlow: "column"}} onClick={e => this.openTicket(e)}>
                                <span>
                                    {this.state.ticket && this.state.ticket.name ? this.state.ticket.name : "..."}
                                    {this.state.ticket && this.state.ticket.renewable && this.state.ticket.active &&
                                    <MdRefresh style={{marginBottom: 10, marginLeft: 4}} size="14px" className="rotate-image"/>
                                    }
                                </span>
                                {this.state.ticket && this.state.ticket.is_enrolment &&
                                <Badge color="secondary">{resourceStrings.is_enrolment}</Badge>
                                }
                            </span>
                        </Media>
                    </Media>
                    {this.isMembershipTicket() &&
                    <div className="mb-0 text-warning">
                        {this.membershipStatus()}
                    </div>
                    }
                </th>
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.ticket && this.state.ticket.id ? this.state.ticket.id : ""}
                    </span>
                </td>
                <td>
                    {this.state.ticket && this.state.ticket.active === true ?
                        (
                            <Badge color="" className="badge-dot">
                                <i className="bg-success"/>
                                {resourceStrings.active}
                            </Badge>) :
                        (
                            <Badge color="" className="badge-dot mr-4">
                                <i className="bg-warning"/>
                                {resourceStrings.not_active}
                            </Badge>
                        )
                    }

                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.ticketEndDate()}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.calcClassesLeft()}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <Button className="btn-icon" color="warning"
                            onClick={e => this.deleteTicket(e)}>
                        <MdDelete/>
                    </Button>
                    <Button color="secondary"
                            onClick={e => this.openTicket(e)}>
                        <MdEdit/>
                    </Button>
                </td>
            </tr>
        )
    }

    deleteTicket(e) {
        e.preventDefault();
        this.props.deleteTicket(this.state.ticket.id)
    }

    openTicket(e) {
        e.preventDefault();
        this.props.openTicket(this.state.ticket.id)
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        resourceStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    }

    ticketEndDate() {
        return (this.state.ticket && this.state.ticket.end !== null && dateHelpers.isValidDate(new Date(this.state.ticket.end))) ? dateHelpers.formatDate(new Date(this.state.ticket.end)) : resourceStrings.unlimited
    }

    isMembershipTicket() {
        return this.state.ticket && this.state.ticket.membership
    }

    membershipStatus() {
        if (this.state.ticket && this.state.ticket.membership) {
            switch (this.state.ticket.subscription_status) {
                case "cancelled":
                    return commonStrings.cancelled
                default:
                    return resourceStrings.membership
            }
        }
    }
}

TicketTableRow.propTypes = propTypes;

export default TicketTableRow;